const seeAll = (btn, blocks, wrap, unwrap, count) => {
  blocks.forEach((item, index) => {
    blocks[index].style.height = 0;
    blocks[index].style.border = 'none';
    blocks[index].style.display = 'none';

    for (var i = 0; i < count; i++) {
      blocks[i].removeAttribute('style');
    }

    btn?.addEventListener('click', function () {
      if (blocks[index].hasAttribute('style')) {
        blocks[index].removeAttribute('style');
        btn.textContent = wrap;
        btn.classList.add('active');
      } else {
        blocks[index].style.display = 'none';

        for (var i = 0; i < count; i++) {
          blocks[i].removeAttribute('style');
        }

        blocks[0].scrollIntoView();
        btn.textContent = unwrap;
        btn.classList.remove('active');
      }
    });
  });
};

export default seeAll;
